import { InlineStack, Text } from "@shopify/polaris";

// A card, shown the way a card is shown: the network's mark and the last four
// digits. Used wherever a card payment is listed, so the two screens cannot
// drift apart.
//
// Icons live in public/images and are referenced by absolute path — they are
// static assets, not bundled modules, so a brand we do not have art for costs
// nothing.
const ICONS = {
  visa: { src: "/images/visa_icon.svg", label: "Visa" },
  mastercard: { src: "/images/mastercard_icon.svg", label: "Mastercard" },
  amex: { src: "/images/amex_icon.svg", label: "American Express" },
};

// SAT tells credit and debit apart — forma 04 vs 28 — so a person about to
// invoice needs to see which one this was, not infer it from the account.
const FUNDING = { credit: "Crédito", debit: "Débito" };

export default function CardBadge({ brand, last4, funding, tone = "subdued" }) {
  const icon = ICONS[String(brand || "").toLowerCase()] || null;
  const kind = FUNDING[String(funding || "").toLowerCase()] || null;
  if (!icon && !last4 && !kind) return null;

  return (
    <InlineStack gap="150" blockAlign="center" wrap={false}>
      {icon ? (
        <img
          src={icon.src}
          alt={icon.label}
          title={icon.label}
          width={26}
          height={16}
          // Lines it up with the text baseline instead of sitting on it.
          style={{ display: "block", borderRadius: 3 }}
        />
      ) : null}
      {last4 ? (
        <Text as="span" tone={tone} variant="bodySm" numeric>
          ****{last4}
        </Text>
      ) : null}
      {kind ? (
        <Text as="span" tone={tone} variant="bodySm">
          {kind}
        </Text>
      ) : null}
    </InlineStack>
  );
}
